// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CommonFooter-module__footer__T47sN {
    --common-footer-height: 44px;
    background-color: transparent;
}

.CommonFooter-module__footer__T47sN .CommonFooter-module__inner__i9rv0 {
    justify-content: center;
}

.CommonFooter-module__fixed__l_GpK {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 250;
    background-color: #fff;
    box-shadow: 0 -4px 14px rgba(15, 23, 42, 0.08);
}

.CommonFooter-module__fixed__l_GpK .CommonFooter-module__inner__i9rv0 {
    justify-content: flex-end;
}

.CommonFooter-module__spacer__cJprI {
    height: var(--common-footer-height, 56px);
}

.CommonFooter-module__inner__i9rv0 {
    min-height: var(--common-footer-height, 56px);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 1rem;
}

.CommonFooter-module__brandLink__BrjUq {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    color: var(--mantine-color-dimmed);
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    font-size: var(--mantine-font-size-xs);
    font-weight: 500;
}

.CommonFooter-module__brandLink__BrjUq:hover {
    color: var(--mantine-color-gray-8);
}

.CommonFooter-module__label__RrCMk {
    line-height: 1;
}

.CommonFooter-module__logo__uvyxW {
    height: 0.8rem;
    width: auto;
    object-fit: contain;
    display: block;
}

@media (min-width: 48em) {
    .CommonFooter-module__inner__i9rv0 {
        padding: 0 1.5rem;
    }
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui/src/components/layout/CommonFooter/CommonFooter.module.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,OAAO;IACP,YAAY;IACZ,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,6CAA6C;IAC7C,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,kCAAkC;IAClC,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".footer {\n    --common-footer-height: 44px;\n    background-color: transparent;\n}\n\n.footer .inner {\n    justify-content: center;\n}\n\n.fixed {\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 250;\n    background-color: #fff;\n    box-shadow: 0 -4px 14px rgba(15, 23, 42, 0.08);\n}\n\n.fixed .inner {\n    justify-content: flex-end;\n}\n\n.spacer {\n    height: var(--common-footer-height, 56px);\n}\n\n.inner {\n    min-height: var(--common-footer-height, 56px);\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 0 1rem;\n}\n\n.brandLink {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    color: var(--mantine-color-dimmed);\n    text-decoration: none;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    font-size: var(--mantine-font-size-xs);\n    font-weight: 500;\n}\n\n.brandLink:hover {\n    color: var(--mantine-color-gray-8);\n}\n\n.label {\n    line-height: 1;\n}\n\n.logo {\n    height: 0.8rem;\n    width: auto;\n    object-fit: contain;\n    display: block;\n}\n\n@media (min-width: 48em) {\n    .inner {\n        padding: 0 1.5rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `CommonFooter-module__footer__T47sN`,
	"inner": `CommonFooter-module__inner__i9rv0`,
	"fixed": `CommonFooter-module__fixed__l_GpK`,
	"spacer": `CommonFooter-module__spacer__cJprI`,
	"brandLink": `CommonFooter-module__brandLink__BrjUq`,
	"label": `CommonFooter-module__label__RrCMk`,
	"logo": `CommonFooter-module__logo__uvyxW`
};
module.exports = ___CSS_LOADER_EXPORT___;
